<template>
  <div class="h-full modal w-full">
    <div class="modal-content">
      <h1
        class="w-full mb-6 text-xl font-semibold tracking-wide text-gray-800 uppercase"
      >
        {{ $t('components.company.statusesStatisticsDetails.title') }}
      </h1>
      <div
        v-if="getLeadsStatusesStatistics?.length > 0"
        class="table-wrapper p-4 border rounded-lg shadow bg-white"
      >
        <table class="w-full text-sm mt-4">
          <tbody class="text-gray-800">
            <tr
              v-for="stats in getLeadsStatusesStatistics[0]?.statuses"
              :key="stats.status"
              class="border-t border-gray-200"
            >
              <td
                class="py-2"
              >
                {{ stats.status }}
              </td>
              <td class="text-right font-medium">
                {{ stats.count?.toLocaleString() || 0 }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer">
      <button
        class="btn-inline"
        @click="$emit('close')"
      >
        {{ $t('common.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import statusForSelect, { defaultSystemStatuses } from '@/lib/leadStatus'
import GET_LEADS_PIPELINE_STATUSES from '@/components/company/queries/GetLeadsPipelineStatuses.gql'
import LEADS_STATUSES_STATISTICS from '@/components/company/queries/LeadsStatusesStatistics.gql'

export default {
  props: {
    companyId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      totalBounces: 0
    }
  },
  apollo: {
    leadsPipelineStatuses: {
      query: GET_LEADS_PIPELINE_STATUSES,
      variables () {
        return {
          input: {
            companyId: this.companyId
          }
        }
      },
      fetchPolicy: 'cache-and-network',
      update (data) {
        if (data.leadsPipelineStatuses) {
          return data.leadsPipelineStatuses
        }
        return []
      }
    },
    getLeadsStatusesStatistics: {
      query: LEADS_STATUSES_STATISTICS,
      variables () {
        return {
          input: {
            companyId: this.companyId
          }
        }
      },
      fetchPolicy: 'cache-and-network',
      update (data) {
        if (data.getLeadsStatusesStatistics) {
          const leadsStatisticsResult = data.getLeadsStatusesStatistics
          const norm = (s) => (s ?? '').trim().toLowerCase()

          const mappedResult = leadsStatisticsResult.map((statistics) => {
            const map = new Map((statistics.statuses ?? []).map((st) => [norm(st.status), st]))

            const statuses = (this.leadsPipelineStatuses || []).reduce((acc, ps) => {
              const st = map.get(norm(ps?.name))
              if (!st) return acc
              acc.push({
                ...st,
                status: defaultSystemStatuses.includes(st.status)
                  ? statusForSelect[st.status]
                  : st.status
              })
              return acc
            }, [])

            return { ...statistics, statuses }
          })

          return mappedResult
        }
        return []
      }
    }
  }
}
</script>
<style scoped>
.table-wrapper table {
  height: auto;
}
.wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem;
}
.table-wrapper {
  flex: 0 0 100%;
}

</style>
